<template lang="pug">
    d2-container()
        el-form(:model="ruleForm",:inline="false", ref="ruleForm", label-width="100px",  label-suffix=":", @keyup.enter.native="ruleFormSubmit()")
            el-form-item(label="LOGO墙" prop="headImg")
                el-input(v-model="ruleForm.headImg" v-show="false")
                //- el-upload(:http-request="uploadSectionFile",action="useless" :headers="headers", :before-upload="beforeAvatarUpload" :show-file-list="false" class="avatar-uploader")
                img(v-if="imageUrl" :src="imageUrl"  @click="openImgdailog" style='width:335px;height:172px')
                i(v-else class="el-icon-plus avatar-uploader-icon" @click="openImgdailog")
                imgupload(v-if="openImg" ref="upimg" :width="335" :height="172" @uploadSuccess='doneup')
        el-button(type="primary" @click="ruleFormSubmit()"  v-if="isAuth('pb:logo:save')"  ) 保 存
</template>
<script>
    import util from '@/libs/util.js'
    export default {
        data () {
            return {
                uploadUrl: this.$http.adornUrl(`/upload/uploadFile`),
                uploadData: null,
                //文件上传时授权
                headers: {
                    token: util.cookies.get('token'),
                    authorization: 'Bearer ' + util.cookies.get('authorization'),
                    'Content-Type': 'application/json; charset=utf-8'
                },
                ruleForm: {
                    id: null,
                    headImg: ''
                },
                imageUrl: '',
                openImg: false,
                uurrll: ''
            }
        },
        created () {
            this.getlogo()
        },
        methods: {
            getfile (e) {
                let that = this
                console.log(e, 888)
                //实例化FileReader API
                var file = e.target.files[0]
                var freader = new FileReader()
                freader.readAsDataURL(file)
                freader.onload = function (e) {
                  that.uurrll = e.target.result //显示图片
                }
            },
            // 查询
            getlogo () {
                this.$http({
                    url: this.$http.adornUrl(`/pbLogo/getId`),
                    method: 'get'
                }).then((data) => {
                    if (data && data.code === 0) {
                        if (data.bean.url != '' && data.bean.url != null) {
                            this.imageUrl = data.bean.url
                        }
                    }
                })
            },
            //保存
            ruleFormSubmit () {
                if (this.ruleForm.headImg == '') return $message.error('请上传logo后再保存！')
                this.$http({
                    url: this.$http.adornUrl(`/pbLogo/save/`),
                    method: 'post',
                    data: {
                        img: this.ruleForm.headImg
                    }
                }).then((data) => {
                    console.log(data)
                    if (data && data.code === 0) {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500
                        })
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            },

            doneup (val, url) {
              this.ruleForm.headImg = val
              this.imageUrl = url
            },
            openImgdailog () {
                this.openImg = true
                this.$nextTick(() => {
                    this.$refs.upimg.init('pbLogo') //传入图片类型参数
                })
            },
            //文件上传前的验证
            beforeAvatarUpload (file) {
                const isJPG = file.type === 'image/jpg' || file.type === 'image/png' || file.type === 'image/jpeg'
                const isLt2M = file.size / 1024 / 1024 < 2

                if (!isJPG) {
                    this.$message.error('上传图片只能是 jpg,jpeg,png 格式!')
                }
                if (!isLt2M) {
                    this.$message.error('上传图片大小不能超过 2MB!')
                }
                return isJPG && isLt2M
            },
            //自定义上传方法
            //没有用el-upload的action方法，如果使用要传递headers属性参数授权
            uploadSectionFile (param) {
                let fd = new FormData()
                fd.append('type', 'pbLogo')
                fd.append('file', param.file)

                this.$http({
                    url: this.$http.adornUrl(`/upload/uploadFile`),
                    method: 'post',
                    data: fd
                }).then((data) => {
                    if (data && data.code === 0) {
                        this.ruleForm.headImg = data.bean.id
                        this.imageUrl = URL.createObjectURL(param.file)
                        this.$message.success('上传成功123!')
                    } else {
                        this.$message.error('上传失败!')
                    }
                })
            }
        }
    }
</script>
<style>
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
</style>
